export const INVITE_PARTNER_START = 'INVITE_PARTNER_START';
export const INVITE_PARTNER_SUCCESS = 'INVITE_PARTNER_SUCCESS';
export const INVITE_PARTNER_ERROR = 'INVITE_PARTNER_ERROR';
